import { render, staticRenderFns } from "./courseListWeekly.vue?vue&type=template&id=fd31f1a6&scoped=true"
import script from "./courseListWeekly.vue?vue&type=script&lang=js"
export * from "./courseListWeekly.vue?vue&type=script&lang=js"
import style0 from "./courseListWeekly.vue?vue&type=style&index=0&id=fd31f1a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd31f1a6",
  null
  
)

export default component.exports